import React from "react";
import { Layout } from "../../shared/components/Layout";
import Footer from "../../shared/components/Footer";
import playstoreImage from "../../../assets/img/playstore.jpeg";
import appstoreImage from "../../../assets/img/appstore.jpeg";

const appstoreLink =
  "https://apps.apple.com/us/app/media4care-familie/id1294644079";
const playstoreLink =
  "https://play.google.com/store/apps/details?id=com.media4care.familienportal&hl=de";

class Downloads extends React.Component {
  render() {
    return (
      <div>
        <Layout title={__("Family Portal")}>
          <div id="downloads" className="flexBox direction-column flex">
            <div className="header c_row">{__("Hello")}</div>
            <div className="c_row">{__("Welcome to the family portal!")}</div>
            <div className="c_row">
              {__(
                "To continue, please download the Family Portal App for Android or iPhone now."
              )}
            </div>
            <div className="c_row">
              {__("Then please log in to the app with your data.")}
            </div>
            <div className="download-info c_row">
              {__("Here is the link to Android app")}
              <br />
              <a href={playstoreLink}>
                <img className='storeImg' src={playstoreImage} />{" "}
              </a>
            </div>
            <div className="download-info c_row">
              {__("Here is the link to iPhone app")}
              <br />
              <a href={appstoreLink}>
                {" "}
                <img className='storeImg' src={appstoreImage} />{" "}
              </a>
            </div>
          </div>
          <Footer />
        </Layout>
      </div>
    );
  }
}

export default Downloads;
